import React from "react"
import styled from "styled-components"
import { GbiBridged } from "Components"
import { theme } from "Theme"

const Wrapper = styled.section`
  color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  min-height: ${(props) => (props.big ? "300px;" : "100px;")};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }

  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: column;
    margin: 0;
    padding: 2rem;
    width: 100%;
  }

  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto 0;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const GalleryGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(200px, 240px);
  background-color: #fff;
  color: #444;
  margin: 0 auto 3rem;
  .box {
    &.a {
      grid-column: 1 / 3;
      grid-row: 1;
    }
    &.b {
      grid-column: 1 / 3;
      grid-row: 3;
    }
    &.c {
      grid-column: 1;
      grid-row: 2;
    }
    &.d {
      grid-column: 2;
      grid-row: 2;
    }
  }
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: minmax(200px, 240px);
    .box {
      &.a {
        grid-column: 1 / 4;
        grid-row: 1;
      }
      &.b {
        grid-column: 3;
        grid-row: 2;
      }
      &.c {
        grid-column: 1;
        grid-row: 2;
      }
      &.d {
        grid-column: 2;
        grid-row: 2;
      }
    }
  }
  @media (min-width: ${theme.breakpoints.m}) {
    .box {
      &.a {
        grid-column: 1 / 3;
        grid-row: 1;
      }
      &.b {
        grid-column: 3;
        grid-row: 1 / 3;
      }
      &.c {
        grid-column: 1;
        grid-row: 2;
      }
      &.d {
        grid-column: 2;
        grid-row: 2;
      }
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const GalleryImage = styled(GbiBridged)`
  &:before {
    background-image: none;
  }
`

const SectionGallery = ({ image1, image2, image3, image4 }) => (
  <>
    <Wrapper>
      <Content>
        <GalleryGrid>
          <GalleryImage className="box a" image={image1} title={"Gallery"} />
          <GalleryImage className="box b" image={image2} title={"Gallery"} />
          <GalleryImage className="box c" image={image3} title={"Gallery"} />
          <GalleryImage className="box d" image={image4} title={"Gallery"} />
        </GalleryGrid>
      </Content>
    </Wrapper>
  </>
)

export default SectionGallery
